import * as z from "zod";
//#region src/__generated__/internal/ui-state/zod/uiStateDtoSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const uiStateDtoSchema = z.object({
	key: z.string().nullish().describe("Ключ состояния").meta({ examples: ["needs_attention_expanded"] }),
	value: z.unknown().nullish().describe("Значение (произвольный JSON)")
}).describe("Состояние элемента UI пользователя");
//#endregion
//#region src/__generated__/internal/ui-state/zod/getSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const getPathKeySchema = z.string();
const getStatus200Schema = uiStateDtoSchema.describe("Состояние элемента UI пользователя");
const getResponseSchema = getStatus200Schema;
//#endregion
//#region src/__generated__/internal/ui-state/zod/uiStateUpdateBodySchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const uiStateUpdateBodySchema = z.object({ value: z.unknown().optional().describe("Значение (произвольный JSON)") }).describe("Тело запроса на сохранение состояния UI");
//#endregion
//#region src/__generated__/internal/ui-state/zod/saveSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const savePathKeySchema = z.string();
const saveStatus200Schema = uiStateDtoSchema.describe("Состояние элемента UI пользователя");
const saveResponseSchema = saveStatus200Schema;
const saveDataSchema = uiStateUpdateBodySchema.describe("Тело запроса на сохранение состояния UI");
//#endregion
export { uiStateUpdateBodySchema as a, getStatus200Schema as c, saveStatus200Schema as i, uiStateDtoSchema as l, savePathKeySchema as n, getPathKeySchema as o, saveResponseSchema as r, getResponseSchema as s, saveDataSchema as t };

//# sourceMappingURL=saveSchema2.js.map